import React, { useEffect, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { useAuth } from '../../context/AuthUserContext';
import { useAppDispatch } from '../../app/hooks';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { getFieldErrors, getErrorMsg } from '../../lib/utils';
import PlacesSearch from './PlacesSearch';
import Upload from '../molecules/Upload';
import EditForm from './EditForm';
import Offset from './Offset';
import Checkbox from '../atoms/Checkbox';
import Input from '../atoms/Input';
import Button from '../atoms/Button';
import { createBillingAccount } from '../../lib/apis/billingAccount';
import styles from '../../styles/components/organisms/UserForm.module.scss';
import { UserFromDecodedIdToken } from '../../services/user';

interface UserFormProps {
  prefill?: any; //User
  onSubmit?: (id?: string) => void;
  onCancel?: () => void;
}

const UserForm = (props: UserFormProps) => {
  const { t } = useTranslation(['common', 'user']);
  const router = useRouter();
  const dispatch = useAppDispatch();
  const { user, updateUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState() as any;
  const [customerType, setCustomerType] = useState() as any;

  const [resetMode, setResetMode] = useState(false);
  const [fieldErrors, setFieldErrors] = useState([]) as any;
  const { prefill, onSubmit, onCancel } = props;
  const formID = 'userForm';

  const { email, billing_accounts } = (prefill as any) || user;

  const formFields: (keyof UserFromDecodedIdToken)[] = [
    'name',
    'family_name',
    'company',
    'job',
    // 'country',
    'phone',
  ];

  const customerTypeOptions = [
    'exhibition-center',
    'congress-center',
    'convention-center',
    'hotel-meeting',
    'service-provider',
    'multi-venue',
    'sports-venue',
    'cultural-venue',
    'other-venue',
    'exhibitor',
    'visitor',
    'organizer',
    'media',
    'sponsor',
    'association',
    'academic',
    'student',
    'other',
  ].map((el) => ({
    label: t(`common:${el}`),
    value: el,
  }));

  useEffect(() => {
    if (!!user && !customerType) {
      setCustomerType([...user.customer_type]);
    }
  }, [user, customerType]);

  const toggleCustomerType = (key: any) => {
    const add = customerType.some((el: string) => el === key) ? [] : [key];
    const arr = [...customerType.filter((el: string) => el !== key), ...add];
    console.log('toggleCustomerType', key, arr);
    setCustomerType(arr);
    if (!arr.length) {
      setFieldErrors([...fieldErrors, 'customer_type']);
      setError(t(`common:form-input-error`));
    } else {
      setFieldErrors([
        ...fieldErrors.filter((el: any) => el !== 'customer_type'),
      ]);
    }
  };

  const handleFieldErrors = (arr: any) => {
    console.log('handleFieldErrors', arr, customerType);
    if (
      !customerType ||
      !customerType.length
      // || fieldErrors.indexOf('customer_type') > -1
    ) {
      setFieldErrors([...arr, 'customer_type']);
      setError(t(`common:form-input-error`));
    } else {
      setFieldErrors([
        ...fieldErrors.filter((el: any) => el !== 'customer_type'),
        ...arr,
      ]);
    }
    // setError(t(`common:form-input-error`));
  };

  const handleError = (error: any) => {
    const errorMsg = getErrorMsg(error);
    switch (errorMsg) {
      default:
        setError(t(`common:form-error`) + ` (${errorMsg})`);
        break;
    }
  };

  // const validFields = (get?: boolean) => {
  //   const inputErrors = getFieldErrors(formID);
  //   setFieldErrors(inputErrors);
  //   if (!!inputErrors.length) {
  //     setError(t(`common:form-input-error`));
  //   } else {
  //     setError('');
  //   }
  //   if (get) {
  //     return !!!inputErrors.length;
  //   }
  // };

  // const cancel = () => {
  //   if (!!onCancel) {
  //     onCancel();
  //   }
  // };

  /**
   * Handle form submit
   */
  const submit = async (formData: any) => {
    // if (!validFields(true)) {
    //   return;
    // }

    if (!!fieldErrors.length) {
      setError(t(`common:form-input-error`));
      return;
    }

    try {
      setLoading(true);
      const res = await updateUser({
        // email,
        name: formData.name,
        family_name: formData.family_name,
        company: formData.company,
        job: formData.job,
        country: formData.country,
        phone: formData.phone,
        customer_type: customerType,
        newsletter: formData.newsletter,
        onboarding_complete: true,
      });

      if (!billing_accounts || !billing_accounts.length) {
        const billingPayload = {
          name: formData.company,
          phone: formData.phone,
          email,
        } as any;

        await createBillingAccount(billingPayload);
      }

      setLoading(false);
      if (!!onSubmit) {
        onSubmit(res.id);
      }
    } catch (err: any) {
      handleError(err);
    } finally {
      setLoading(false);
    }
  };

  const onImageSelect = (files: any) => {
    console.log('onImageSelect', files);
  };

  // useEffect(() => {
  //   console.log('hallo', user);
  // }, [user]);

  if (!user) {
    return <></>;
  }

  return (
    <EditForm
      className={styles.userForm}
      checkOnce
      id={formID}
      error={error}
      loading={loading}
      onSubmit={submit}
      onFieldError={handleFieldErrors}
    >
      <Row>
        <Col xs={8}>
          <br />
          <br />
          <br />
          <br />
        </Col>

        <Col xs={8} md={4}>
          <h2>{t('common:sign-in-details')}</h2>
          <Input
            disabled
            name="email"
            icon="email"
            label={t('common:email')}
            error={fieldErrors.indexOf('email') > -1}
            // onChange={validFields}
            defaultValue={email}
          />
        </Col>

        <Col xs={8} md={4}>
          {/* <h2>{t('common:profile-image')}</h2>
          <Upload
            bg
            className={styles.upload}
            optional
            name="avatar"
            onChange={onImageSelect}
          /> */}
        </Col>

        <Col xs={8}>
          <br />
          <br />
          <br />
          <br />
        </Col>

        <Col xs={8} md={5}>
          <h2>{t('common:contact')}</h2>
        </Col>

        <Col xs={8}>
          <Offset>
            {formFields.map((key, i) =>
              key === 'country' ? (
                <PlacesSearch
                  half
                  float
                  key={i}
                  name={key}
                  type="country"
                  label={t(`common:${key}`)}
                  defaultValue={user[key] || ''}
                  error={fieldErrors.indexOf(key) > -1}
                />
              ) : key === 'phone' ? (
                <Input
                  reset
                  half
                  key={i}
                  placeholder={t(`common:input-phone-exp`, {
                    countryCode: '49',
                  })}
                  unit={t(`common:input-phone-help`)}
                  optional
                  name={key}
                  format={key}
                  icon={key}
                  label={t(`common:${key}`)}
                  error={fieldErrors.indexOf(key) > -1}
                  defaultValue={(user[key] || '') as string}
                />
              ) : (
                <Input
                  reset
                  key={i}
                  half={key !== 'email'}
                  full={key === 'email'}
                  // optional={key === 'job'}
                  name={key}
                  format={key}
                  icon={key}
                  label={t(`common:${key}`)}
                  error={fieldErrors.indexOf(key) > -1}
                  defaultValue={(user[key] || '') as string}
                />
              )
            )}
          </Offset>

          <br />
          <br />
          <br />
          <br />
          {t('common:describe-business')}

          <Offset>
            <br />
            {customerTypeOptions.map((el: any, i: number) => {
              return (
                <Checkbox
                  key={i}
                  optional
                  third
                  name={el.value}
                  label={t(`common:${el.value}`)}
                  error={fieldErrors.indexOf('customer_type') > -1}
                  defaultValue={(customerType || []).indexOf(el.value) > -1}
                  onChange={() => {
                    toggleCustomerType(el.value);
                  }}
                />
              );
            })}
          </Offset>

          <div>
            <br />
            <br />

            <Checkbox
              optional
              name="newsletter"
              // onChange={validFields}
              defaultValue={!!user.newsletter}
              label={<span>{t('common:accept-news')}</span>}
            />

            <br />
            <br />
          </div>
        </Col>
      </Row>
    </EditForm>
  );
};

export default UserForm;
